var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0147 11.381L17.0001 16.3661L16.3662 17L11.3811 12.0146C10.2806 12.9689 8.84438 13.5465 7.27342 13.5465C3.80864 13.5465 1 10.7378 1 7.27341C1 3.80864 3.80872 1 7.27342 1C10.7379 1 13.5465 3.80872 13.5465 7.27341C13.5465 8.84437 12.9689 10.2806 12.0146 11.3811L12.0147 11.381ZM7.27341 12.6503C10.243 12.6503 12.6504 10.243 12.6504 7.27334C12.6504 4.30371 10.243 1.89603 7.27341 1.89603C4.30377 1.89603 1.89609 4.30371 1.89609 7.27334C1.89609 10.243 4.30377 12.6503 7.27341 12.6503Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.1f33ccab7288dfa27e99377336c1c6de.svg";
export { ForwardRef as ReactComponent };